import styled from 'styled-components'

import InputMask from 'react-input-mask';

import { FaTrashAlt } from 'react-icons/fa';

const itemHeight = 30

const checkWidth = 3
const checkHeight = 50

export const Background = styled.div`
  position: absolute;

  display: block;
  width: 100%;
  height: ${props => props.selected ? itemHeight * 1.1 : itemHeight}px;
  padding-left: 1em;
  padding-right: ${props => props.input ? '1em' : '0'};

  color: #e6f2fe;
  background: rgba(5, 75, 130, 1);
  z-index: 2;
  clip-path: ${ props => props.selected ? 'polygon(0% 0%,100% 0%,96% 100%,2% 94%)' : 'polygon(0% 0%,100% 0%,97% 100%,2% 100%)' };
  transition: 0.3s;

  @media screen and (max-width: 812px) {
    height: ${props => props.selected ? itemHeight * 1.5 : itemHeight * 1.4}px;
    
    /* padding-left: 0.7em; */
  }
`

export const Text = styled.div`
  position: absolute;
  top: ${ props => props.selected ? '-5px' : '0' };
  left: ${ props => props.selected ? '3px' : '0' };

  display: flex;
  width: 100%;
  height: ${props => props.selected ? itemHeight * 1.1 : itemHeight}px;
  padding-left: 1em;
  justify-content: left;
  align-items: center;

  text-decoration: none;
  user-select: none;
  font-family: 'Barthowheel-Regular';
  text-align: center;
  font-size: 1em;
  color: ${ props => props.selected ? "#054b82" : "#FFF" };
  background: ${ props => props.selected ? "rgba(219, 239, 245, 1)" : "" };
  z-index: ${ props => props.selected ? 4 : 2 };
  clip-path: ${ props => props.selected ? 'polygon(0% 0%,100% 0%,96% 100%,2% 94%)' : 'polygon(0% 0%,100% 0%,97% 100%,2% 100%)' };
  transition: 0.3s;

  @media screen and (max-width: 812px) {
    height: ${props => props.selected ? itemHeight * 1.5 : itemHeight * 1.4}px;
  }
`

export const Input = styled(InputMask).attrs({
  type: 'text'
})`
  position: absolute;

  display: flex;
  width: 100%;
  height: ${itemHeight}px;
  padding-left: 1em;
  padding-right: 1em;
  justify-content: left;
  text-align: ${props => props.center ? 'center' : 'left'};
  align-items: center;

  text-decoration: none;
  outline: none;
  border: none;
  font-family: 'Barthowheel-Regular';
  font-size: 1em;
  color: #FFF;
  background: rgba(5, 75, 130, 1);
  z-index: 2;
  clip-path: polygon(0% 0%,100% 0%,97% 100%,2% 100%);
  transition: 0.3s;

  @media screen and (max-width: 812px) {
    height: ${itemHeight * 1.4}px;
  }

  &:focus{
    color: #054b82;
    background: rgba(219, 239, 245, 1);
    /* clip-path: polygon(2% 0, 100% 12%, 99% 82%, 0 100%); */
    z-index: 4;
    transition: 0.3s;
  }

  ::placeholder{
    color: #60b2e1;
    opacity: 0.4;
  }
`

export const Check = styled.div`
  position: absolute;
  width: ${checkWidth}%;
  height: ${checkHeight}%;
  top: ${props => props.selected ? "37%" : "50%" };
  right: 0.5em;

  z-index: 10;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.95em;
  -webkit-user-select: none;
  /* background: ${props => props.completed ? "green" : "red"}; */
  transition: 0.3s;
  cursor: pointer;

  &:hover{
    transform: translateY(-50%) scale(1.35, 1.35);
    transition: 0.3s;
  }

  @media screen and (max-width: 812px) {
    width: ${checkWidth * 3}%;
    height: ${checkHeight * 2}%;
    right: 0em;
    font-size: 1.1em;
    transform: translateY(-50%) scale(1.35, 1.35);
  }
`

export const Item = styled.div`
  position: relative;
  width: ${props => props.width ? props.width : '90%'};
  height: ${itemHeight}px;
  margin-top: 5px;
  margin-left: 0.5em;

  cursor: pointer;
  user-select: none;

  &:nth-child(n+2){
    margin-top: 0.725em;

    @media screen and (max-width: 812px) {
      margin-top: 0.45em;
    }
  }

  &:hover ${Text}{
    top: -5px;
    left: ${ props => props.selected ? "3px" : "-4px" };
    color: #054b82;
    background: rgba(219, 239, 245, 1);
    /* clip-path: polygon(2% 0, 100% 12%, 99% 82%, 0 100%); */
    z-index: 4;
    transition: 0.3s;
  }

  &:hover ${Input}{
    color: #054b82;
    background: rgba(219, 239, 245, 1);
    /* clip-path: polygon(2% 0, 100% 12%, 99% 82%, 0 100%); */
    z-index: 4;
    transition: 0.3s;
  }

  &:hover ${Check}{
    top: 37%;
    transition: 0.3s;
  }

  @media screen and (max-width: 812px) {
    height: ${itemHeight * 1.5}px;
  }
`

export const NewItem = styled.div`
  position: relative;

  width: 90%;
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: space-between;
`

export const Name = styled.div`
  width: 30%;
  margin: 0.1em 0;
`

export const Desc = styled.div`
  width: 55%;
  margin: 0.1em 0 0 1.5em;
`

export const Reward = styled.div`
  width: 5%;
  margin: 0.1em 0;
`

export const Trash = styled(FaTrashAlt).attrs({
  color: '#fff'
})`
  width: 5%;
  margin: 0.85em 0 0 2.5em;
  transition: 0.1s;

  &:hover{
    transform: scale(1.25);
    transition: 0.1s;
  }
`